// extracted by mini-css-extract-plugin
export default {"summary-openings-column-view":"SummaryOpeningsColumnView_summary-openings-column-view__GPLJS"};